import { GraphQLClient } from "graphql-request";
import * as Dom from "graphql-request/dist/types.dom";
import { GraphQLError } from "graphql-request/dist/types";
import { print } from "graphql";
import gql from "graphql-tag";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
    DateTime: any;
    /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSON: any;
};

export type CreateLogRequestInput = {
    restaurantCode: Scalars["String"];
    macAddress: Scalars["String"];
    timeStartAt: Scalars["String"];
};

export type EmailInput = {
    email: Scalars["String"];
};

export type LogRequest = {
    __typename?: "LogRequest";
    id: Scalars["Float"];
    inputFilePath: Maybe<Scalars["String"]>;
    outputFilePath: Maybe<Scalars["String"]>;
    status: LogRequestStatus;
    restaurantCode: Scalars["String"];
    macAddress: Scalars["String"];
    timeStartAt: Scalars["String"];
    metadata: Maybe<Scalars["JSON"]>;
    createdAt: Scalars["DateTime"];
    updatedAt: Scalars["DateTime"];
    filteredData: Maybe<Scalars["JSON"]>;
    userMappings: Array<LogRequestUserMapping>;
};

export enum LogRequestStatus {
    NotIntiated = "NOT_INTIATED",
    LogUploadInProgress = "LOG_UPLOAD_IN_PROGRESS",
    LogUploadSuccessful = "LOG_UPLOAD_SUCCESSFUL",
    LogUploadFailed = "LOG_UPLOAD_FAILED",
    ProcessingUploadedLogs = "PROCESSING_UPLOADED_LOGS",
    Successful = "SUCCESSFUL",
    ProcessingUploadedLogsFailed = "PROCESSING_UPLOADED_LOGS_FAILED",
}

export type LogRequestUserMapping = {
    __typename?: "LogRequestUserMapping";
    id: Scalars["Float"];
    user: UserProfile;
    logRequest: LogRequest;
    filterQuery: Maybe<Scalars["String"]>;
    isNotificationRequired: Scalars["Boolean"];
    notificationSent: Scalars["Boolean"];
    createdAt: Scalars["DateTime"];
    updatedAt: Scalars["DateTime"];
};

export type LoginInput = {
    code: Scalars["String"];
    scope: Scalars["String"];
};

export type Mutation = {
    __typename?: "Mutation";
    createLogRequest: LogRequest;
};

export type MutationCreateLogRequestArgs = {
    data: CreateLogRequestInput;
};

export type Query = {
    __typename?: "Query";
    userByEmail: UserProfile;
    authStatus: UserProfile;
    login: UserProfile;
    getLogRequest: LogRequest;
    logRequestUserMappings: Array<LogRequestUserMapping>;
};

export type QueryUserByEmailArgs = {
    data: EmailInput;
};

export type QueryLoginArgs = {
    data: LoginInput;
};

export type QueryGetLogRequestArgs = {
    id: Scalars["Float"];
};

export type UserProfile = {
    __typename?: "UserProfile";
    authorizationToken: Maybe<Scalars["String"]>;
    id: Scalars["Float"];
    email: Scalars["String"];
    firstName: Scalars["String"];
    lastName: Scalars["String"];
    disabled: Scalars["Boolean"];
    lastLogin: Maybe<Scalars["DateTime"]>;
    logRequestUserMappings: Array<LogRequestUserMapping>;
};

export type AuthStatusQueryVariables = Exact<{ [key: string]: never }>;

export type AuthStatusQuery = { __typename?: "Query" } & {
    authStatus: { __typename?: "UserProfile" } & Pick<
        UserProfile,
        "id" | "email" | "firstName" | "lastName" | "authorizationToken"
    >;
};

export type GetLogRequestQueryVariables = Exact<{
    id: Scalars["Float"];
}>;

export type GetLogRequestQuery = { __typename?: "Query" } & {
    getLogRequest: { __typename?: "LogRequest" } & Pick<
        LogRequest,
        | "id"
        | "status"
        | "restaurantCode"
        | "macAddress"
        | "timeStartAt"
        | "filteredData"
        | "createdAt"
        | "updatedAt"
        | "metadata"
        | "inputFilePath"
        | "outputFilePath"
    >;
};

export type CreateLogRequestMutationVariables = Exact<{
    data: CreateLogRequestInput;
}>;

export type CreateLogRequestMutation = { __typename?: "Mutation" } & {
    createLogRequest: { __typename?: "LogRequest" } & Pick<
        LogRequest,
        | "id"
        | "status"
        | "restaurantCode"
        | "macAddress"
        | "timeStartAt"
        | "filteredData"
        | "createdAt"
        | "updatedAt"
        | "metadata"
        | "inputFilePath"
        | "outputFilePath"
    >;
};

export type LogRequestUserMappingsQueryVariables = Exact<{
    [key: string]: never;
}>;

export type LogRequestUserMappingsQuery = { __typename?: "Query" } & {
    logRequestUserMappings: Array<
        { __typename?: "LogRequestUserMapping" } & Pick<
            LogRequestUserMapping,
            | "id"
            | "filterQuery"
            | "isNotificationRequired"
            | "notificationSent"
            | "createdAt"
            | "updatedAt"
        > & {
                logRequest: { __typename?: "LogRequest" } & Pick<
                    LogRequest,
                    | "id"
                    | "status"
                    | "restaurantCode"
                    | "macAddress"
                    | "timeStartAt"
                    | "createdAt"
                    | "metadata"
                    | "inputFilePath"
                    | "outputFilePath"
                >;
                user: { __typename?: "UserProfile" } & Pick<
                    UserProfile,
                    "firstName" | "lastName"
                >;
            }
    >;
};

export const AuthStatusDocument = gql`
    query authStatus {
        authStatus {
            id
            email
            firstName
            lastName
            authorizationToken
        }
    }
`;
export const GetLogRequestDocument = gql`
    query getLogRequest($id: Float!) {
        getLogRequest(id: $id) {
            id
            status
            restaurantCode
            macAddress
            timeStartAt
            filteredData
            createdAt
            updatedAt
            metadata
            inputFilePath
            outputFilePath
        }
    }
`;
export const CreateLogRequestDocument = gql`
    mutation createLogRequest($data: CreateLogRequestInput!) {
        createLogRequest(data: $data) {
            id
            status
            restaurantCode
            macAddress
            timeStartAt
            filteredData
            createdAt
            updatedAt
            metadata
            inputFilePath
            outputFilePath
        }
    }
`;
export const LogRequestUserMappingsDocument = gql`
    query logRequestUserMappings {
        logRequestUserMappings {
            id
            filterQuery
            isNotificationRequired
            notificationSent
            logRequest {
                id
                status
                restaurantCode
                macAddress
                timeStartAt
                createdAt
                metadata
                inputFilePath
                outputFilePath
            }
            user {
                firstName
                lastName
            }
            createdAt
            updatedAt
        }
    }
`;

export type SdkFunctionWrapper = <T>(
    action: (requestHeaders?: Record<string, string>) => Promise<T>,
    operationName: string
) => Promise<T>;

const defaultWrapper: SdkFunctionWrapper = (action, _operationName) => action();
const AuthStatusDocumentString = print(AuthStatusDocument);
const GetLogRequestDocumentString = print(GetLogRequestDocument);
const CreateLogRequestDocumentString = print(CreateLogRequestDocument);
const LogRequestUserMappingsDocumentString = print(
    LogRequestUserMappingsDocument
);
export function getSdk(
    client: GraphQLClient,
    withWrapper: SdkFunctionWrapper = defaultWrapper
) {
    return {
        authStatus(
            variables?: AuthStatusQueryVariables,
            requestHeaders?: Dom.RequestInit["headers"]
        ): Promise<{
            data?: AuthStatusQuery | undefined;
            extensions?: any;
            headers: Dom.Headers;
            status: number;
            errors?: GraphQLError[] | undefined;
        }> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.rawRequest<AuthStatusQuery>(
                        AuthStatusDocumentString,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders }
                    ),
                "authStatus"
            );
        },
        getLogRequest(
            variables: GetLogRequestQueryVariables,
            requestHeaders?: Dom.RequestInit["headers"]
        ): Promise<{
            data?: GetLogRequestQuery | undefined;
            extensions?: any;
            headers: Dom.Headers;
            status: number;
            errors?: GraphQLError[] | undefined;
        }> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.rawRequest<GetLogRequestQuery>(
                        GetLogRequestDocumentString,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders }
                    ),
                "getLogRequest"
            );
        },
        createLogRequest(
            variables: CreateLogRequestMutationVariables,
            requestHeaders?: Dom.RequestInit["headers"]
        ): Promise<{
            data?: CreateLogRequestMutation | undefined;
            extensions?: any;
            headers: Dom.Headers;
            status: number;
            errors?: GraphQLError[] | undefined;
        }> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.rawRequest<CreateLogRequestMutation>(
                        CreateLogRequestDocumentString,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders }
                    ),
                "createLogRequest"
            );
        },
        logRequestUserMappings(
            variables?: LogRequestUserMappingsQueryVariables,
            requestHeaders?: Dom.RequestInit["headers"]
        ): Promise<{
            data?: LogRequestUserMappingsQuery | undefined;
            extensions?: any;
            headers: Dom.Headers;
            status: number;
            errors?: GraphQLError[] | undefined;
        }> {
            return withWrapper(
                (wrappedRequestHeaders) =>
                    client.rawRequest<LogRequestUserMappingsQuery>(
                        LogRequestUserMappingsDocumentString,
                        variables,
                        { ...requestHeaders, ...wrappedRequestHeaders }
                    ),
                "logRequestUserMappings"
            );
        },
    };
}
export type Sdk = ReturnType<typeof getSdk>;
